import * as React from "react";
function SvgCircleQuestion(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle
        cx={16}
        cy={16}
        r={15}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path d="M16.32 8A4.75 4.75 0 0013 9.27a5.14 5.14 0 00-1.62 3.38l2.26.35c.28-1.83 1.06-2.82 2.4-2.82a2 2 0 011.41.56 1.81 1.81 0 01.55 1.42 3.15 3.15 0 01-1.41 2.33c-.42.35-.78.7-1.13 1.06a2 2 0 00-.28 1.06v2.11H17a19.14 19.14 0 01.07-2c.07-.28.28-.42.56-.56.63-.42 1.27-1 1.83-1.41a3 3 0 00.78-1.13 3.38 3.38 0 00.38-1.62 3.65 3.65 0 00-1.27-2.8A4 4 0 0016.32 8zM16 20.83a1.63 1.63 0 00-1.27 2.82A1.92 1.92 0 0016 24a1.64 1.64 0 001.27-.42 1.75 1.75 0 000-2.4 1.6 1.6 0 00-1.27-.35z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCircleQuestion);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
